import classes from '../index.module.css';
import React, { useState } from 'react';
import TabsComponent from '../../../../components/Tabs/Tabs';
import RedisCurrent from './RedisCurrent';
import ActivationEvents from './ActivationEvents';
import { useQueryParamWithDefault } from '../../../../hooks';
import { NumberParam } from 'use-query-params';

const MFRRMonitoring = ({ area, cId, selectedEicCode, setSelectedEicCode, eicCodeOptions }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('sub2Tab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'Current',
            component: (
                <>
                    <RedisCurrent area={area} selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'History',
            component: (
                <>
                    <ActivationEvents area={area} selectedEicCode={selectedEicCode} setSelectedEicCode={setSelectedEicCode} eicCodeOptions={eicCodeOptions} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
            />
        </div>
    );
};

export default MFRRMonitoring;
